import React from 'react';
import { ArrowRight, Star, Shield, Clock, ThumbsUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CTASection } from '../components/CTASection';
export function HomePage() {
  return <div className="flex flex-col w-full" data-id="element-247">
      {/* Hero Section */}
      <section className="relative bg-[#0c2340] py-24 sm:py-32 overflow-hidden border-t border-white/10" data-id="element-248">
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '32px 32px'
      }} aria-hidden="true" data-id="element-249" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#0a1c33]/80" aria-hidden="true" data-id="element-250" />

        <div className="relative max-w-7xl mx-auto px-4 text-center" data-id="element-251">
          <span className="inline-block py-1 px-3 rounded-full bg-[#b87333]/20 text-[#b87333] font-semibold text-sm mb-6 border border-[#b87333]/30" data-id="element-252">
            Serving Orange County, CA
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6 max-w-4xl mx-auto leading-tight" data-id="element-253">
            Protect Your Home With{' '}
            <span className="text-[#b87333]" data-id="element-254">Seamless Gutters</span>
          </h1>
          <p className="text-lg sm:text-xl text-slate-300 max-w-2xl mx-auto mb-10" data-id="element-255">
            Professional installation, repair, and maintenance of premium
            aluminum and copper rain gutters for residential and commercial
            properties.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-256">
            <Link to="/appointment" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#b87333] hover:bg-[#a0632a] text-white font-bold py-4 px-8 rounded-lg transition-colors shadow-lg shadow-[#b87333]/20" data-id="element-257">
              Get a Free Estimate
              <ArrowRight className="w-5 h-5" data-id="element-258" />
            </Link>
            <Link to="/services" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-transparent hover:bg-white/10 text-white border-2 border-white font-bold py-4 px-8 rounded-lg transition-colors" data-id="element-259">
              View Our Services
            </Link>
          </div>
        </div>
      </section>

      {/* Trust Banner */}
      <section className="bg-slate-50 py-12 border-b border-slate-200" data-id="element-260">
        <div className="max-w-7xl mx-auto px-4" data-id="element-261">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-262">
            <div className="flex flex-col items-center" data-id="element-263">
              <Shield className="w-10 h-10 text-[#0c2340] mb-3" data-id="element-264" />
              <h3 className="font-bold text-slate-900" data-id="element-265">Licensed & Insured</h3>
              <p className="text-sm text-slate-500" data-id="element-266">Full protection</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-267">
              <Star className="w-10 h-10 text-[#0c2340] mb-3" data-id="element-268" />
              <h3 className="font-bold text-slate-900" data-id="element-269">5-Star Rated</h3>
              <p className="text-sm text-slate-500" data-id="element-270">By local homeowners</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-271">
              <Clock className="w-10 h-10 text-[#0c2340] mb-3" data-id="element-272" />
              <h3 className="font-bold text-slate-900" data-id="element-273">Fast Service</h3>
              <p className="text-sm text-slate-500" data-id="element-274">Quick turnaround</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-275">
              <ThumbsUp className="w-10 h-10 text-[#0c2340] mb-3" data-id="element-276" />
              <h3 className="font-bold text-slate-900" data-id="element-277">100% Guarantee</h3>
              <p className="text-sm text-slate-500" data-id="element-278">Satisfaction promised</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-20 px-4 bg-white" data-id="element-279">
        <div className="max-w-7xl mx-auto" data-id="element-280">
          <div className="text-center mb-16" data-id="element-281">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0c2340] mb-4" data-id="element-282">
              Expert Gutter Solutions
            </h2>
            <div className="w-24 h-1 bg-[#b87333] mx-auto rounded-full mb-6" data-id="element-283" />
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-284">
              We offer comprehensive rain gutter services to keep your property
              safe from water damage year-round.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-285">
            {[{
            title: 'Seamless Installation',
            desc: 'Custom-fit aluminum and copper gutters fabricated on-site for a perfect, leak-proof fit.'
          }, {
            title: 'Gutter Guards',
            desc: 'Premium leaf protection systems to keep debris out and water flowing freely.'
          }, {
            title: 'Repairs & Maintenance',
            desc: 'Expert fixes for leaks, sagging, and damage to extend the life of your gutters.'
          }].map((service, i) => <div key={i} className="bg-slate-50 rounded-2xl p-8 border border-slate-200 hover:shadow-lg transition-shadow group" data-id="element-286">
                <div className="w-14 h-14 bg-[#0c2340] rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#b87333] transition-colors" data-id="element-287">
                  <Shield className="w-7 h-7 text-white" data-id="element-288" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-289">
                  {service.title}
                </h3>
                <p className="text-slate-600 mb-6" data-id="element-290">{service.desc}</p>
                <Link to="/services" className="text-[#b87333] font-semibold flex items-center gap-2 hover:text-[#0c2340] transition-colors" data-id="element-291">
                  Learn more <ArrowRight className="w-4 h-4" data-id="element-292" />
                </Link>
              </div>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-293" />
    </div>;
}